import React, {useState} from "react";
import {ORDER_BY} from "@app/constants/Common";

const OrderListByUpdatedTime = (props) => {
    const [searchOrderBy, setSearchOrderBy] = useState(ORDER_BY.DESC_UPDATE_DATE);

    const {onChange} = props
    const onChangeOrderBy = (event) => {
        setSearchOrderBy(event.target.value)
        if (onChange) {
            onChange(event.target.value)
        }
    }

    return <>
        <select className='mr-0'
                style={{padding: '0.375rem 0.75rem', backgroundColor: '#fff', border: '1px solid #ced4da',
                    borderRadius: '0.25rem',
                    boxShadow: 'inset 0 0 0 transparent',
                    transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out'}}
                name={'order_by'}
                value={searchOrderBy}
                onChange={event => onChangeOrderBy(event)}>
            <option value='1'>Nhập mới hơn trước</option>
            <option value='2'>Nhập cũ hơn trước</option>
        </select>
    </>
}

export default OrderListByUpdatedTime;